function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeelingsorryCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-376"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.79,
    y: 336.42,
    width: 26.48,
    height: 11.19,
    transform: "translate(856.07 684.03) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.56,
    y: 350.53,
    width: 26.48,
    height: 11.19,
    transform: "translate(885.61 712.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.02,
    y: 350.53,
    width: 26.48,
    height: 11.19,
    transform: "translate(826.52 712.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 350.53,
    width: 26.48,
    height: 11.19,
    transform: "translate(143.93 712.25) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 48.58,
    width: 26.48,
    height: 11.19,
    transform: "translate(143.93 108.34) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.96,
    y: 62.69,
    width: 26.48,
    height: 11.19,
    transform: "translate(114.39 136.56) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.56,
    y: 48.59,
    width: 26.48,
    height: 11.19,
    transform: "translate(885.61 108.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.6,
    y: 181.73,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.83,
    y: 167.62,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.53,77.65H244.25v245.4H68.53ZM239,82.86H73.74v235H239Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.78,
    y: 84.23,
    width: 5.21,
    height: 236.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 88.19,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 183.64) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 96.36,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 199.98) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 104.53,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 216.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 112.7,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 232.65) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 120.86,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 248.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 129.03,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 265.33) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 137.2,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 281.66) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 145.37,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 298) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 153.54,
    width: 185.18,
    height: 7.26,
    transform: "translate(312.78 314.34) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.28,
    y: 86.72,
    width: 1.3,
    height: 141.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.62 234.08 82.25 234.08 81.09 227.43 78.78 227.43 77.62 234.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.59,
    y: 86.72,
    width: 1.3,
    height: 176.93,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.92 268.54 77.55 268.54 76.39 261.89 74.08 261.89 72.92 268.54",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.71,
    y: 76.63,
    width: 201.37,
    height: 15.19,
    transform: "translate(312.78 168.45) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.69,
    cy: 114.23,
    r: 37.6,
    transform: "translate(-0.18 227.81) rotate(-31.29)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.42,
    cy: 115.07,
    r: 35.88,
    transform: "translate(9.03 258.36) rotate(-35.47)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.42,
    cy: 115.07,
    r: 33.61,
    transform: "translate(9.08 258.5) rotate(-35.49)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.27,107.94c-15.31,9.27-40.46,24.48-54.52,32.82a33.67,33.67,0,0,1-9.19-12.35l46.5-43.1A33.69,33.69,0,0,1,441.27,107.94Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,116.24a33,33,0,0,1-2.22,10.92L397.86,147a32.71,32.71,0,0,1-5.29-2.28C405.23,137.4,428.37,124.08,442,116.24Z",
    style: {
      fill: "#ebebeb",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.09,
    y: 83.9,
    width: 0.65,
    height: 5.09,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.78,
    y: 87.73,
    width: 0.65,
    height: 5.09,
    transform: "translate(7.65 209.13) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.3,
    y: 98.21,
    width: 0.65,
    height: 5.09,
    transform: "translate(104.54 382.6) rotate(-60)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.25,
    y: 114.74,
    width: 5.09,
    height: 0.65,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.08,
    y: 129.06,
    width: 5.09,
    height: 0.65,
    transform: "translate(-13.27 209.25) rotate(-30.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.56,
    y: 139.53,
    width: 5.09,
    height: 0.65,
    transform: "translate(76.04 411.36) rotate(-60.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.09,
    y: 141.15,
    width: 0.65,
    height: 5.09,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.4,
    y: 137.31,
    width: 0.65,
    height: 5.09,
    transform: "translate(-13.3 230.09) rotate(-30)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.88,
    y: 126.83,
    width: 0.65,
    height: 5.09,
    transform: "translate(104.52 439.82) rotate(-59.99)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434.49,
    y: 114.74,
    width: 5.09,
    height: 0.65,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.66,
    y: 100.43,
    width: 5.09,
    height: 0.65,
    transform: "translate(7.71 230.26) rotate(-30.02)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.18,
    y: 89.95,
    width: 5.09,
    height: 0.65,
    transform: "translate(133.36 411.4) rotate(-60.03)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.9 86.2 410.01 117.34 406.82 117.3 408.04 86.19 408.9 86.2",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.3 104.21 407.35 117.58 405.83 114.78 427.88 103.45 428.3 104.21",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.5,115.07a1.09,1.09,0,1,1-1.08-1.09A1.08,1.08,0,0,1,409.5,115.07Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-376"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.13,314.47c-4.33-4.23-9.91-9.35-16.52-7.53-6.22,1.72-8.6,8.51-9.72,14.17-1.43,7.29-2.55,14.65-3.71,22s-2.26,14.84-3.33,22.26q-.9,6.28-1.78,12.58-.45,3.13-.88,6.29c-.28,2-.63,4.11-.74,6.18,0,.66,1,.76,1.15.13.8-3.5,1.13-7.13,1.64-10.68s1-7.14,1.56-10.71c1-7.09,2.11-14.17,3.17-21.26s2.18-14.17,3.31-21.25c1-6,1.41-13.46,6.73-17.42,2.92-2.17,6.65-2.19,9.95-.93,3.51,1.34,6.3,3.84,9,6.32A.09.09,0,0,0,445.13,314.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.21,310.14s-8.84-3.18-13.2,3.27.85,22.86,41.09,32.11a113.47,113.47,0,0,0-9.68-36.37C448.79,290.34,433.42,297.46,439.21,310.14Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.79,342.84a32.15,32.15,0,0,0-2-3.26l-2-3.1-1.58-2.31c0-.18.05-.38.08-.57,0-.35.09-.7.13-1.05.1-.75.21-1.5.32-2.26s.24-1.49.38-2.24a11.8,11.8,0,0,1,.53-2.37c.05-.12-.16-.18-.18,0a8.71,8.71,0,0,1-.36,1.33l-.27,1c-.19.76-.38,1.53-.55,2.3s-.29,1.42-.41,2.13c-.06.35-.11.69-.16,1-.72-1-1.45-2-2.2-3-2.14-2.82-4.4-5.53-6.74-8.17,0,0,0,0,0-.07.21-4.23.11-8.42,1-12.58,0-.11-.14-.17-.17-.06-.88,3.91-1.75,8-1.5,12q-1.26-1.41-2.55-2.79c-2-2.1-3.95-4.18-6-6.21-.08-.08-.21,0-.13.12,3.39,3.65,6.61,7.46,9.74,11.33a69.35,69.35,0,0,0-7.35.27c-2.73.2-5.44.55-8.15.92a.09.09,0,0,0,0,.18,79.38,79.38,0,0,1,8.14-.73c2.63-.11,5.24,0,7.86,0,1.69,2.11,3.37,4.22,5,6.36h-.37c-.62,0-1.23,0-1.85,0-1.22,0-2.45.11-3.67.21a55,55,0,0,0-7.43,1.11.09.09,0,0,0,0,.18c2.47-.28,4.95-.51,7.44-.6,1.18,0,2.37,0,3.56,0h1.85a2.24,2.24,0,0,0,1-.09c1.08,1.41,2.17,2.81,3.24,4.22.85,1.13,1.7,2.26,2.52,3.41s1.61,2.44,2.55,3.53A.09.09,0,0,0,464.79,342.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.06,319.28a26.87,26.87,0,0,0-4.3-.2c-1.44,0-2.88,0-4.31.09a.09.09,0,1,0,0,.18c1.45-.11,2.91-.13,4.37-.11s2.82.15,4.22.12A0,0,0,0,0,443.06,319.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.69,322.53c.16-1.38.34-2.76.63-4.11a.09.09,0,1,0-.18,0c-.2,1.36-.47,2.7-.67,4.05q-.15,1-.27,2a9.52,9.52,0,0,0-.17,1.92c0,.12.21.13.24,0a12.13,12.13,0,0,0,.21-1.91C455.54,323.83,455.61,323.18,455.69,322.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,307.3c-.35,1.34-.7,2.69-1,4.05-.12.69-.23,1.39-.32,2.08a8.76,8.76,0,0,0-.14,2s.09,0,.11,0a12.54,12.54,0,0,0,.32-1.93q.13-1,.3-2c.25-1.4.5-2.79.85-4.17C453.24,307.25,453.07,307.19,453,307.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,388.92c-.22-2.54-.47-5.07-.73-7.6q-.8-7.51-1.82-15c-.67-5-1.31-10-2.11-14.93a36.38,36.38,0,0,0-1.53-6.78,6.43,6.43,0,0,0-3.76-4.24c-4.73-1.64-7.93,3.27-9.84,6.75-.06.1.1.18.16.08,1.15-1.64,4.31-6.26,7.9-6.05,2.42.15,4.35,1.86,5.51,7.89,2.89,15,5.5,45.48,5.8,47.47.16,1.06.91,1,.91-.12C401.15,393.89,400.86,391.4,400.64,388.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,345.24s4.14-14.61-5-7.31c-15.23,12.16-15.77,38.62-15.77,38.62s27.07-15.72,30.44-26.09C396.8,335,382.13,345.24,382.13,345.24Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,352.41c-2.12.43-4.28.71-6.42,1l-3.05.43c-.68.09-1.38.16-2.07.24,2-2.77,4.05-5.54,6-8.37.08-.11-.09-.23-.18-.14a66.32,66.32,0,0,0-4.52,5.22l-1.2-3.39c-.46-1.31-1-2.61-1.29-4,0-.11-.2-.06-.17.06.37,1.34.63,2.7,1,4s.74,2.58,1.2,3.84c-1,1.29-1.95,2.61-2.87,3.94-.47-1.32-1-2.6-1.45-3.94a.09.09,0,0,0-.18.06c.49,1.48.75,3,1.21,4.51-.63.91-1.25,1.82-1.84,2.73-1.09,1.69-2.12,3.41-3.13,5.15a.38.38,0,0,0-.24.4c-1.71,3-3.34,6-4.94,9a.09.09,0,0,0,.16.09c1.61-3,3.39-5.9,5.25-8.76h0a4.68,4.68,0,0,1,.89-.17l.93-.2c.7-.15,1.39-.33,2.09-.51,1.37-.34,2.73-.66,4.13-.9.11,0,.06-.2-.06-.18-1.64.32-3.28.5-4.94.69-.78.09-1.56.19-2.33.32l-.12,0c1-1.48,2-2.95,3-4.4s2-2.84,3-4.24c.94-.14,1.87-.38,2.8-.56l3.15-.61c2.09-.42,4.18-.89,6.28-1.24C387.42,352.57,387.37,352.39,387.25,352.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,353.85l-.36-1.16a20.92,20.92,0,0,1-.62-2.45c0-.12-.2-.06-.18.05.18.83.37,1.65.56,2.47a15.73,15.73,0,0,0,.71,2.43c.08.19.37.11.31-.09C371.28,354.68,371.12,354.27,371,353.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,349c-1.23.18-2.48.27-3.72.38s-2.48.28-3.72.47c-.07,0-.07.11,0,.11,1.25-.09,2.48-.19,3.72-.35s2.48-.35,3.73-.43C390.14,349.2,390.13,349,390,349Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.56,370.42c-.48-10.76-1.16-21.5-2.24-32.22-.54-5.34-1.14-10.67-1.89-16a114.77,114.77,0,0,0-3.09-15.47c-1.1-3.87-2.56-7.76-5.15-10.9a11.67,11.67,0,0,0-10.4-4.54c-4.71.58-8.5,3.55-11.78,6.77-3.68,3.62-7,7.56-10.45,11.43-.86,1-1.72,2-2.57,2.95-.07.09.06.22.13.13,3.34-3.83,6.8-7.55,10.42-11.1,3.35-3.29,6.79-6.88,11.43-8.24a11.82,11.82,0,0,1,6.64-.15,10.52,10.52,0,0,1,4.54,2.87c2.61,2.72,4.07,6.39,5.12,9.95,2.89,9.89,3.93,20.26,5,30.47,1.09,10.38,1.83,20.78,2.35,31.2s.93,21,1.94,31.4c.13,1.29.29,2.58.46,3.86.11.87,1.45.87,1.38,0C421.54,392,421.05,381.23,420.56,370.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,299.24s6.15-11.37-1.11-15-31.56,23.47-38.66,63.13c0,0,39.24-17.36,52.57-34.66S396.44,291.59,385.42,299.24Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.19,308.49c-4.41,0-8.81-.33-13.22-.3.83-.95,1.65-1.9,2.49-2.84a39.76,39.76,0,0,0,3.44-4c.07-.09-.07-.22-.16-.15a31.92,31.92,0,0,0-3.33,3.35q-1.67,1.75-3.3,3.54c-1.69,1.82-3.34,3.67-5,5.53v-2.85c0-1.5,0-3,.05-4.49,0-3,0-6.08.23-9.1,0-.12-.17-.11-.18,0-.21,3-.53,6.07-.68,9.12-.07,1.49-.11,3-.12,4.49,0,.77,0,1.54,0,2.31,0,.42,0,.87,0,1.3l-.78.87c-3.52,4-6.87,8.18-10.12,12.41,0-.23,0-.47-.06-.7,0-.47-.1-.93-.16-1.4-.11-1-.25-2-.4-3s-.29-1.89-.45-2.83-.44-2.13-.52-3.21a.09.09,0,1,0-.18,0,27.07,27.07,0,0,1,.37,3.23l.27,2.91c.09,1,.18,1.95.28,2.92,0,.46.09.93.14,1.4,0,.23.05.46.08.7a1.32,1.32,0,0,0,.19.55l-1.68,2.19c-2.22,2.95-4.41,5.93-6.59,8.9-.07.09.06.22.13.12,2.07-2.69,4.2-5.34,6.36-8,1.61.07,3.26-.05,4.87-.07s3.4,0,5.11-.05c.11,0,.11-.18,0-.18-1.7,0-3.4.06-5.1.06s-3.14-.07-4.69,0q2.85-3.47,5.74-6.89l2.11-2.49a9.94,9.94,0,0,0,2,.06h2.32l4.35-.06c3-.05,6-.15,9-.15a.1.1,0,0,0,0-.19c-3,0-6-.16-9-.24-1.45,0-2.9-.08-4.35-.1l-2.32,0c-.44,0-.9,0-1.34,0l4.94-5.86a.22.22,0,0,0,.09-.1c1.61-1.9,3.22-3.8,4.84-5.68l.68-.77c4.57.14,9.13-.16,13.71-.07C391.31,308.68,391.31,308.49,391.19,308.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.93,316.29h-1.06a.08.08,0,0,0,0,.16h1.07C389.06,316.47,389.05,316.29,388.93,316.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.56,316.3c-1.41,0-2.83-.05-4.24-.09l-2.12-.06a7.64,7.64,0,0,0-2,0c-.07,0-.06.11,0,.13a7.74,7.74,0,0,0,2,.14l2.12,0c1.41,0,2.82,0,4.23,0A.09.09,0,1,0,386.56,316.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.22,329.55a58.71,58.71,0,0,0-8.67-.79c-.05,0,0,.06,0,.07,2.88.27,5.77.43,8.63.89C374.3,329.74,374.34,329.56,374.22,329.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.43,316.92l-.09-.76c-.08-.56-.17-1.13-.26-1.7-.16-1.07-.35-2.15-.56-3.22,0-.1-.19-.07-.18,0q.21,1.67.36,3.33c.05.55.09,1.09.14,1.64a4.73,4.73,0,0,0,.22,1.55.21.21,0,0,0,.38-.05A2.06,2.06,0,0,0,362.43,316.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.18,284.64c-1.41-2.61-3.2-6.07-6.7-5.85-2.9.18-4.2,3.14-4.82,5.58-1.91,7.55-2.05,15.52-2.42,23.26-.78,16.35-1.49,32.73-1.6,49.1q0,6.81,0,13.62c.05,4.63,0,9.29.33,13.91a.34.34,0,0,0,.68,0c0-4-.12-7.92-.13-11.88s0-7.73.08-11.59q.18-11.75.62-23.48c.29-7.78.63-15.55,1-23.32.17-3.89.33-7.77.51-11.66s.33-7.53.76-11.27c.24-2.1.55-4.2,1-6.26a8.72,8.72,0,0,1,1.81-4.2,4,4,0,0,1,5.11-.37,10.82,10.82,0,0,1,3.63,4.53C420.08,284.84,420.23,284.75,420.18,284.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,283.39s-2.89-10.17,3.49-5.09c10.6,8.48,11,26.91,11,26.91s-18.86-11-21.2-18.18C409,276.27,419.23,283.39,419.23,283.39Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.73,297.65c-.17-.28-.35-.55-.53-.83a6.31,6.31,0,0,0,0-.87c0-.44,0-.88,0-1.32,0-.86.05-1.71.1-2.57a.1.1,0,0,0-.19,0c0,.84-.07,1.69-.1,2.53,0,.42,0,.84,0,1.27,0,.16,0,.35,0,.54-.74-1.15-1.5-2.29-2.28-3.4-.23-.33-.47-.65-.7-1a19.36,19.36,0,0,1-.06-3.32c0-1.18,0-2.37.07-3.55,0-.11-.18-.11-.18,0,0,1.23-.1,2.46-.16,3.69a25.59,25.59,0,0,0-.07,2.63c-1.82-2.48-3.75-4.87-5.71-7.24-.06-.08-.2,0-.14.11,1.21,1.54,2.37,3.11,3.51,4.7-2.22-.52-4.47-.82-6.73-1.14-.11,0-.16.16,0,.17,2.38.37,4.73,1,7.08,1.48h.05c.9,1.27,1.8,2.55,2.68,3.83l1.07,1.57h-.1l-.73-.1c-.52-.06-1.05-.1-1.57-.14-1.09-.09-2.18-.15-3.27-.21-.11,0-.11.18,0,.19,1.07,0,2.14.1,3.2.22l1.69.2.74.09.21,0,1.81,2.67c1.07,1.57,2,3.26,3.16,4.78a.08.08,0,0,0,.14-.09A49,49,0,0,0,429.73,297.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,286.15c0-.39,0-.79,0-1.18a16,16,0,0,1,.1-2.5c0-.13-.18-.15-.18,0,0,.83-.09,1.65-.13,2.47,0,.41,0,.83,0,1.24v.57a1.67,1.67,0,0,0,0,.59.08.08,0,0,0,.16,0,1.68,1.68,0,0,0,0-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,290.37c-.7-.12-1.42-.16-2.13-.22s-1.55-.13-2.33-.23a.09.09,0,1,0,0,.18c1.49.09,3,.36,4.46.41C422.77,290.52,422.79,290.38,422.71,290.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.63,290.43c.06.08,0,.3,0,.39v1.76a1.61,1.61,0,0,0,0,.62,0,0,0,0,0,.07,0,.63.63,0,0,0,0-.3v-.33c0-.23,0-.47,0-.71v-1c0-.1,0-.31,0-.39S428.51,290.26,428.63,290.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.61,339c-4-3-7.52-7.25-12.86-7.46-4.4-.17-7.49,3.14-9.25,6.83a38.56,38.56,0,0,0-2.16,6.08q-1.18,4.19-2.24,8.4-2.09,8.29-3.54,16.73c-.53,3.13-1,6.27-1.43,9.42a78.34,78.34,0,0,0-.92,9.66.5.5,0,0,0,1,.11c.54-2.64.76-5.36,1.15-8s.8-5.36,1.25-8c.91-5.34,2-10.66,3.16-15.94,1.14-5,2.26-10.06,3.87-14.92,1.15-3.48,3-7.54,6.76-8.8,5.72-1.9,10.92,2.94,15.11,6.09C420.58,339.16,420.71,339,420.61,339Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.51,336.11s-3.65-10.44,1.63-12.49c7.93-3.07,28.67,20.29,24.61,56.08,0,0-16-8.82-27.86-18.75S400,338,405.24,334.69,416.51,336.11,416.51,336.11Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.35,372a27.25,27.25,0,0,0-1.93-3.61c-.67-1.22-1.36-2.44-2.07-3.65-1.37-2.36-2.74-4.72-4.15-7l-.7-1.13c0-.14.06-.28.09-.42l.24-1c.17-.77.31-1.56.45-2.34.29-1.53.56-3.09,1-4.59,0-.11-.15-.15-.18,0-.33,1.53-.81,3-1.26,4.53-.22.74-.46,1.48-.66,2.22-.06.26-.13.51-.2.77-1.7-2.79-3.43-5.57-5.3-8.26a3.55,3.55,0,0,0,.18-1.15l.18-1.56c.14-1.18.28-2.36.45-3.53a69,69,0,0,1,1.26-6.86c0-.11-.15-.14-.18,0-.57,2.25-1.19,4.51-1.62,6.79-.21,1.12-.41,2.25-.56,3.38-.07.56-.13,1.13-.19,1.7,0,.16-.05.34-.07.51-.57-.81-1.15-1.62-1.75-2.41-1.83-2.41-3.73-4.76-5.64-7.1-.07-.09-.22,0-.15.1a125.9,125.9,0,0,1,9,13.16c.53.84,1,1.69,1.56,2.53l-.51-.06c-.67-.09-1.35-.13-2-.19q-2-.19-4.05-.36c-2.7-.21-5.41-.38-8.1-.66-.12,0-.15.16,0,.17,2.73.32,5.44.75,8.16,1.14l4,.54a15.46,15.46,0,0,0,3.08.32q1.6,2.58,3.19,5.17a4.34,4.34,0,0,0-.72,0h-3.86c-1.74,0-3.47,0-5.21,0-.12,0-.1.18,0,.18,1.76,0,3.51.11,5.27.2.84,0,1.67.09,2.51.15.41,0,.83.07,1.25.09a2.72,2.72,0,0,0,1.1,0l2.7,4.39q1.24,2,2.53,4a31.46,31.46,0,0,0,2.72,4.08C440.25,372.2,440.39,372.15,440.35,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,343.1a26.5,26.5,0,0,1-.72,3.41c-.3,1.16-.63,2.31-1,3.44a.12.12,0,1,0,.22.07c.35-1.13.67-2.27,1-3.41s.45-2.33.74-3.47C432.92,343,432.73,343,432.72,343.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,350.1a1.31,1.31,0,0,0-.87-.33l-1.51-.21c-.94-.13-1.88-.23-2.82-.34-1.95-.23-3.91-.42-5.86-.66a.09.09,0,0,0,0,.18c1.84.22,3.67.5,5.51.74.9.12,1.8.25,2.71.35l1.3.15a4.66,4.66,0,0,1,1.49.25A.08.08,0,0,0,420.94,350.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.69,365.83c-.92-.07-1.85-.1-2.78-.13l-1.4,0-.67,0a3.61,3.61,0,0,1-.87-.05c-.13,0-.14.21,0,.18a3.75,3.75,0,0,1,.82,0l.73,0,1.4.09c.92.05,1.85.11,2.77.11C432.79,366,432.8,365.84,432.69,365.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.34,361.83l.3-1.57.57-3.1c0-.11-.16-.14-.18,0-.23,1-.46,2-.68,3q-.18.75-.33,1.5l-.15.7a1.88,1.88,0,0,0-.08.74c0,.09.14.15.2.06A3.84,3.84,0,0,0,438.34,361.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.08 384.6 385.2 397.29 388.99 440.13 422.54 440.13 427.27 397.29 428.67 384.6 384.08 384.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.08 384.6 385.2 397.29 427.27 397.29 428.67 384.6 384.08 384.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.76,
    y: 381.14,
    width: 51.24,
    height: 10.29,
    transform: "translate(812.76 772.58) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-376"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.67 440 85.5 439.76 140.34 439.67 250 439.5 359.66 439.67 414.5 439.75 469.33 440 414.5 440.24 359.66 440.33 250 440.5 140.34 440.33 85.5 440.24 30.67 440",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-376"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.15,360l0,.14s0,.06,0,.1,0,.16.05.27l0,.18a3.08,3.08,0,0,1,.07.39c0,.09,0,.18.05.28s.07.42.12.66.15.81.23,1.29l.45,2.44c.05.26.1.54.15.83s.14.78.22,1.19.16.92.25,1.41a0,0,0,0,1,0,0c.06.34.13.69.19,1.05.19,1.07.39,2.21.62,3.43a.29.29,0,0,1,0,.09c.24,1.36.5,2.82.78,4.35.07.4.15.8.23,1.2s.16.84.23,1.26c0,0,0,0,0,0,0,.26.09.53.15.8v0q.57,3.19,1.23,6.76c.15.8.29,1.61.44,2.43.29,1.6.59,3.24.9,4.93.08.39.15.78.21,1.18q.67,3.67,1.39,7.64c.06.27.1.54.15.81.23,1.24.46,2.49.68,3.77a1.59,1.59,0,0,1,.06.3l.33,1.82q.66,3.66,1.36,7.49c.12.63.24,1.27.35,1.92.23,1.29.47,2.59.71,3.9.3,1.63.6,3.27.9,4.94s.6,3.34.91,5c.16.85.31,1.7.47,2.55.18,1,.37,2,.55,3.07H302c-10.66-44.29-19.65-80-19.65-80Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.21,370q6.49,35,13.12,70h1.2c-4.59-23.39-9.32-46.74-14-70.1C214.46,369.68,214.18,369.77,214.21,370Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,360s0,.05,0,.14,0,.06,0,.1,0,.16.05.27l0,.18a3.08,3.08,0,0,1,.07.39c0,.09,0,.18.05.28s.08.42.12.66.15.81.23,1.29c.14.71.28,1.52.45,2.44.05.26.1.54.15.83s.14.78.22,1.19.16.92.25,1.41a0,0,0,0,1,0,0c.06.34.13.69.19,1.05.2,1.07.4,2.21.62,3.43a.29.29,0,0,1,0,.09c.25,1.36.51,2.8.79,4.33.08.4.15.81.22,1.22s.16.84.23,1.26c0,0,0,0,0,0,.06.26.1.53.15.8v0c.39,2.12.8,4.38,1.23,6.76.15.8.29,1.61.44,2.43.3,1.6.6,3.24.9,4.93.08.39.15.78.21,1.18q.69,3.69,1.39,7.64c.06.27.1.54.15.81.23,1.24.46,2.49.68,3.77a1.59,1.59,0,0,1,.06.3l.33,1.82q.67,3.66,1.36,7.49c.12.63.24,1.27.35,1.92.24,1.29.47,2.59.71,3.9.3,1.63.6,3.27.9,4.94s.61,3.34.91,5c.16.85.31,1.7.47,2.55.18,1,.37,2,.56,3.07H259l3.47-35.52.12-1.26.14-1.36h0l.68-6.95h0l.59-6L266.79,360Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.05,440h93.21c.16-8.58.33-16.88.54-24.71h0c0-.19,0-.38,0-.57,0,0,10.88-6.44,16.74-11.49a20.69,20.69,0,0,0,2.74-2.72s0,0,0,0h0c3.75-4.78,7.51-23.16,15.29-40.45h-114C148.05,396,149.35,424.88,152.05,440Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,399.24c-5.55,2.27-10.54,5.76-15.46,9.13-5.11,3.49-9.8,7.53-14.72,11.28-.19.15,0,.46.2.32,5.18-3.31,10.61-6.22,15.74-9.63s10.16-6.53,14.49-10.7C268.42,399.48,268.23,399.14,268,399.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.7,367.17c-.66,3.55-1.53,7.07-2.29,10.6-.72,3.31-1.25,6.68-2.12,10a16.92,16.92,0,0,1-4.64,8.34c-1.3,1.21-2.73,2.28-4.12,3.38-.74.6-1.55,1.17-2.33,1.78.1-.47.19-1,.27-1.43.24-1.35.46-2.69.69-4,.5-3,1-6,1.44-9,.9-5.89,1.73-11.84,3-17.67a.19.19,0,0,0-.37-.1c-1.47,5.78-3.09,11.5-4.36,17.33-.63,2.85-2.87,17-3,18s-.19,2.07-.22,3.1a12.46,12.46,0,0,0,0,3.17.27.27,0,0,0,.49,0h0a12.84,12.84,0,0,0,.9-3.06q.39-1.51.66-3.06c.07-.36.12-.74.17-1.12,1.39-.85,2.69-2,4-2.9s2.82-2,4.15-3.12a16,16,0,0,0,5.07-7.92,57.82,57.82,0,0,0,1.66-10.14c.45-4,.77-8,1.33-12C269.1,367,268.74,366.93,268.7,367.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85,391.89c1.48-.77,7.25.6,17.74-1.19a12,12,0,0,0,5.66-2.3c2.74-2.23,4.81-5.82,6.46-8.89a45.65,45.65,0,0,0,4.52-11c.05-.24.39-.12.35.1-.39,2.17-.61,4.34-1.18,6.49a40,40,0,0,1-2.17,5.89c-1.59,3.56-3.44,7.38-6.63,9.79-3.35,2.52-8,3-12.08,3.28-2.35.16-11.56-.09-12.79-1.4A.52.52,0,0,1,173.85,391.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,224.58C269,237.2,353.12,269.48,372,258c14.07-8.56,12.06-26.93.09-38.78-10.41-10.31-88.41-13.21-110.24-13.81C241.1,204.8,224,212.18,246.26,224.58Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.19,253.05l33.9-46.51s-58.66-5.71-83.43-3.57c-25.82,2.23-31.11,12.33.06,26.7C283.42,243.82,302.19,253.05,302.19,253.05Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.47,244.08c.68-1.2,1.53-2.31,2.31-3.44s1.61-2.32,2.41-3.49c1.63-2.36,3.3-4.69,5-7,3.36-4.64,6.7-9.29,10.14-13.87.94-1.26,1.89-2.52,2.87-3.75s2.15-2.53,3.17-3.82c.06-.09.17,0,.12.1-.8,1.17-1.5,2.41-2.29,3.59s-1.64,2.41-2.48,3.59q-2.49,3.51-5,7c-3.34,4.54-6.66,9.1-10.1,13.57l-2.89,3.74c-1,1.3-1.95,2.69-3.07,3.9C296.54,244.22,296.42,244.16,296.47,244.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8,210.27a15.89,15.89,0,0,0-1.31,4.23,15.44,15.44,0,0,0,2.36-3.75,15.78,15.78,0,0,0,1.31-4.23A15.75,15.75,0,0,0,273.8,210.27Zm12.77,22.08a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.4,15.4,0,0,0,286.57,232.35Zm-35.19-15.84a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.71,15.71,0,0,0,251.38,216.51Zm51.16-2.34a15.67,15.67,0,0,0-2.06-3.92,17.18,17.18,0,0,0,3,8.24A15.2,15.2,0,0,0,302.54,214.17Zm10.28,17a16,16,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3A15.54,15.54,0,0,0,312.82,231.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.72,229.66c30.7,14.15,49.47,23.39,49.47,23.39L313,238.17l-81.26-27.8C229.41,215.09,235.51,221.73,252.72,229.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.4,122.08c-6.3-8.77-22.35-21-38.38-30.45-7.78-4.61-31.51-15.46-35.5-9.77s2.66,9.49,2.66,9.49-10.71-3.09-14.21,3S246,106,246,106s-11.24-2.37-14.29,4,8.49,10.14,8.49,10.14-10.17-2.64-10.49,3.63c-.38,7.56,18.92,10.31,27.26,15.84,1.9,1.25,36.6,28.16,36.6,28.16Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.34,120.3c14.19,2.07,20,5.42,30.77,14.59.21.18.52-.09.32-.3-9.69-9.93-16.42-15.2-31-15C239.69,119.62,239.67,120.21,240.34,120.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.49,105.75c14.55,3.43,20.92,7,32.87,15.79.16.13.39-.15.23-.29-11-9.59-17.83-14.69-32.82-16.2C245.1,105,244.82,105.6,245.49,105.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.37,91.69c13.84,4.34,21,8,31.5,18a.27.27,0,0,0,.39-.37c-9.71-11.25-18.61-15.84-31.72-18C253.65,91.14,253.49,91.42,254.37,91.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,176.41s-17.55-3.87-24.88-7.26-30-26.12-25.37-31.3c6-6.68,21.65,3.86,28.65,10,0,0,13.81-15.47,26.69-10.34S299.05,176.41,299.05,176.41Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.05,136.56c9.85-2.16,18.51,6.52,25.75,12a.82.82,0,0,0,1.31-.36c6.22-6.09,16.78-12.88,25.81-11.17a.21.21,0,0,0,.11-.4c-9.44-3.16-20.35,2.67-26.74,9.78-7.33-5.73-16.4-14.06-26.27-9.94A.05.05,0,0,0,251.05,136.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,241.68c-.63,19.43-23.67,18.09-33.62,8.85-23.37-21.67-57.82-65.89-67.16-93.15-3-8.77,32.28-47.31,39.14-40.15C332.39,129.93,383.12,202.25,381.84,241.68Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.66,223c1.72,1.75,3.37,3.54,5,5.35s3.27,3.62,4.89,5.44l4.81,5.51c.79.92,1.6,1.83,2.42,2.74s1.63,1.81,2.45,2.72a54.12,54.12,0,0,1-5.43-4.94c-1.73-1.73-3.38-3.54-5-5.37s-3.2-3.69-4.72-5.61S324.07,225,322.66,223Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.46,234.42c.82,1.18,1.53,2.33,2.24,3.51.34.59.69,1.18,1,1.79a16.84,16.84,0,0,1,.89,1.92,11,11,0,0,1-2.76-3.21,12,12,0,0,1-.92-1.91A6.81,6.81,0,0,1,332.46,234.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.94,379.16H156s20.61-128.72,70.33-172.74c6.14-5.44,20-4.2,29,.29,3.23,1.61,14.82,17.82,18.13,33.16S291.3,378.7,290.94,379.16Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.79,243.55a15.5,15.5,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3.05A15.54,15.54,0,0,0,210.79,243.55Zm65.64,15a1.77,1.77,0,0,0-.17.12l.18,0S276.43,258.54,276.43,258.51Zm-35.06,20.3a16,16,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3.05A15.54,15.54,0,0,0,241.37,278.81ZM223,334.71a15.54,15.54,0,0,0-3.92,2.07,15.54,15.54,0,0,0,4.32-1,15.71,15.71,0,0,0,3.92-2.07A15.54,15.54,0,0,0,223,334.71Zm-30.87-39a16,16,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3.05A15.54,15.54,0,0,0,192.17,295.74Zm-27.68,77.74a15.67,15.67,0,0,0-3.92,2.06,17.06,17.06,0,0,0,8.24-3.06A15.55,15.55,0,0,0,164.49,373.48Zm59.59-4.87a15.67,15.67,0,0,0-3.92,2.06,17.06,17.06,0,0,0,8.24-3.06A15.21,15.21,0,0,0,224.08,368.61Zm66.39,5.48a18,18,0,0,0-2.81.8,15.83,15.83,0,0,0-3.92,2.06,15.62,15.62,0,0,0,4.32-1,20,20,0,0,0,2.5-1.14C290.53,374.59,290.51,374.34,290.47,374.09Zm-27.89-40.9a15.67,15.67,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3.05A15.2,15.2,0,0,0,262.58,333.19ZM224.69,222.72a15.67,15.67,0,0,0-2.06-3.92,17.18,17.18,0,0,0,3.05,8.24A15.2,15.2,0,0,0,224.69,222.72ZM195,373.7a15.5,15.5,0,0,0-2.06-3.92A17.18,17.18,0,0,0,196,378,15.2,15.2,0,0,0,195,373.7Zm-5.92-37.59A15.48,15.48,0,0,0,187,332.2a15.55,15.55,0,0,0,1,4.31,15.37,15.37,0,0,0,2.07,3.92A15.54,15.54,0,0,0,189.08,336.11Zm51.33-22.34a15.83,15.83,0,0,0-2.06-3.92,17.18,17.18,0,0,0,3.05,8.24A15.54,15.54,0,0,0,240.41,313.77Zm-18.16-48.19a15.71,15.71,0,0,0-2.07-3.92,17.06,17.06,0,0,0,3.06,8.24A15.54,15.54,0,0,0,222.25,265.58Zm24.86,110a14.46,14.46,0,0,0,.75,3.63h1.2A15.54,15.54,0,0,0,247.11,375.53Zm38.23-28a15.37,15.37,0,0,0-2.07-3.92,15.92,15.92,0,0,0,1,4.31,15.37,15.37,0,0,0,2.07,3.92A15.47,15.47,0,0,0,285.34,347.54ZM262,238.06a15.48,15.48,0,0,0-2.07-3.91,15.93,15.93,0,0,0,1,4.31,15,15,0,0,0,2.06,3.92A15.54,15.54,0,0,0,262,238.06Zm-10.6-21.55a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.71,15.71,0,0,0,251.38,216.51ZM207.23,317.57a15.34,15.34,0,0,0-4.23-1.32,15.5,15.5,0,0,0,3.76,2.36,15.78,15.78,0,0,0,4.23,1.31A15.46,15.46,0,0,0,207.23,317.57Zm-34.89,35.15a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.4,15.4,0,0,0,172.34,352.72Zm91.22,8.76a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.71,15.71,0,0,0,263.56,361.48Zm-2.9-55.75a15.54,15.54,0,0,0-4.23-1.31,15.1,15.1,0,0,0,3.75,2.35,15.8,15.8,0,0,0,4.23,1.32A15.44,15.44,0,0,0,260.66,305.73Zm-9.28-47.32a15.43,15.43,0,0,0-4.23-1.31,17.11,17.11,0,0,0,8,3.66A15.4,15.4,0,0,0,251.38,258.41Zm-55.6,13.11a15.32,15.32,0,0,0-1.31,4.23,17.2,17.2,0,0,0,3.66-8A15.46,15.46,0,0,0,195.78,271.52Zm44.81,77.68a15.55,15.55,0,0,0-1.32,4.23,15.44,15.44,0,0,0,2.36-3.75,15.78,15.78,0,0,0,1.31-4.23A15.59,15.59,0,0,0,240.59,349.2ZM268,280.63a15.5,15.5,0,0,0-1.31,4.24,15.65,15.65,0,0,0,2.35-3.76,15.43,15.43,0,0,0,1.31-4.23A15.59,15.59,0,0,0,268,280.63ZM206.7,353.2a15.43,15.43,0,0,0-1.31,4.23,17.2,17.2,0,0,0,3.66-8A15.77,15.77,0,0,0,206.7,353.2Zm-35.12-37.56a15.5,15.5,0,0,0-1.31,4.24,15.65,15.65,0,0,0,2.35-3.76,15.43,15.43,0,0,0,1.31-4.23A15.91,15.91,0,0,0,171.58,315.64Zm47.78-21a15.16,15.16,0,0,0-1.31,4.24,16,16,0,0,0,2.35-3.76,15.78,15.78,0,0,0,1.31-4.23A15.59,15.59,0,0,0,219.36,294.67Zm17.57-54.82a15.89,15.89,0,0,0-1.31,4.23,15.44,15.44,0,0,0,2.36-3.75,15.78,15.78,0,0,0,1.31-4.23A15.75,15.75,0,0,0,236.93,239.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,383.79c0-7.55,2.19-53.17.89-68.13-.44-5,16.88-60.93,21.35-79.71,4.2-17.62-4.77-25.4-17.94-8.81-10.95,13.8-39.57,67.69-45.35,82.08s-11.8,62.87-11.76,73.12C150.47,390.45,203.21,391.25,203.24,383.79Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,448.75c-5.19,2.61-9.39-1.7-9.39-1.7a12.38,12.38,0,0,1-6.57,5.28c-4.9,1.42-9.29-5.65-9.29-5.65a15.21,15.21,0,0,1-7.82,4.46c-4.83.89-10.26-5.61-10.26-5.61a13.39,13.39,0,0,1-9.35-.41c-7.79-3.67-9.34-16.72-10.41-25s4.25-35.19,4.67-39.95l52.55-5s15.38,35.81,15.25,45.73C218.24,429.3,214.79,445.81,209,448.75Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,446.85c2.24-8.87,1.75-17.91,1.76-27a.16.16,0,0,0-.31,0c.09,9-1.61,17.91-1.88,26.9A.22.22,0,0,0,199.8,446.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.39,446.42a24.51,24.51,0,0,0,.13-6.23c-.11-2.21-.26-4.41-.44-6.62q-.53-6.6-1.4-13.19c0-.19-.33-.2-.31,0,.35,4.39.63,8.79.79,13.19.09,2.21.15,4.41.2,6.62a28.15,28.15,0,0,0,.42,6.22A.32.32,0,0,0,184.39,446.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.62,445.34c.46-1.73,0-3.84-.19-5.61-.2-2-.4-4-.58-6-.37-4-.73-8-.95-12,0-.2-.33-.2-.32,0,.21,4.08.36,8.18.61,12.26q.18,3,.39,6c.12,1.71.08,3.85.84,5.42C165.46,445.46,165.59,445.43,165.62,445.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,293.72l-54.49.18s29.77-50.86,46-69.67c16.94-19.61,28.23-18,21.59,15.7C221.3,273.1,214.71,293.72,214.71,293.72Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,271.52a15.32,15.32,0,0,0-1.31,4.23,17.2,17.2,0,0,0,3.66-8A15.46,15.46,0,0,0,195.78,271.52Zm8.12-44.46-.56.69a12,12,0,0,0,2.17.51A11.4,11.4,0,0,0,203.9,227.06Zm-17.42,28a19.83,19.83,0,0,0-.91-2.06l-.64,1h0c.14.5.3,1,.47,1.47a15.54,15.54,0,0,0,2.07,3.92A15.54,15.54,0,0,0,186.48,255Zm35.77,10.56a15.71,15.71,0,0,0-2.07-3.92,15.54,15.54,0,0,0,1,4.32c.2.51.41,1,.63,1.51.15-.62.3-1.24.46-1.88Zm2.44-42.86a15.67,15.67,0,0,0-2.06-3.92,17.18,17.18,0,0,0,3.05,8.24A15.2,15.2,0,0,0,224.69,222.72Zm-54.62,59.14a16,16,0,0,0-3.88,2l0,0h0a17.21,17.21,0,0,0,8.22-3.05A15.54,15.54,0,0,0,170.07,281.86Zm40.72-38.31a15.5,15.5,0,0,0-3.92,2.06,17.18,17.18,0,0,0,8.24-3.05A15.54,15.54,0,0,0,210.79,243.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.15,285.12c1.37-.15,2.77-.11,4.14-.13l4.24-.08c2.87-.06,5.74-.07,8.6-.06,5.73,0,11.46,0,17.18.11,1.58,0,3.15.07,4.72.14s3.31.27,5,.34c.1,0,.08.15,0,.16-1.42,0-2.84.19-4.26.24s-2.91.08-4.37.09c-2.86,0-5.72,0-8.59,0-5.64-.05-11.28-.08-16.92-.26l-4.72-.16c-1.64-.05-3.33,0-5-.22C169.08,285.26,169.06,285.13,169.15,285.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,268.45a16.57,16.57,0,0,0,2.41-5.83s-.06-.05-.07,0a33.4,33.4,0,0,1-2.2,5.19l.51-2.25c.6-2.73,1.21-5.44,1.68-8.19,0,0-.06-.07-.07,0-1.37,4.66-2.53,9.4-3.79,14.1s-2.54,9.53-3.79,14.3c-.69,2.61-1.38,5.21-2,7.82-.89.08-1.58.05-2.37.12-.21,0-.23.38,0,.4a15.76,15.76,0,0,0,3-.05C218,285.65,220.06,277.05,222,268.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.91,213.65a46.47,46.47,0,0,0,16.22,17.29,23.48,23.48,0,0,0,10.88,3.8,9.75,9.75,0,0,0,5.82-1.23,11.65,11.65,0,0,0,3.77-4.62,23.39,23.39,0,0,0,2.07-6.6,55.53,55.53,0,0,0,.79-7.84c0-.1.15-.08.14,0-.07,2.49.06,5-.2,7.46a25.62,25.62,0,0,1-1.38,6.41,14.68,14.68,0,0,1-3.26,5.24,8.8,8.8,0,0,1-5.63,2.46,21.11,21.11,0,0,1-11.81-2.94,39.84,39.84,0,0,1-9.7-7.57,44,44,0,0,1-7.92-11.78A.12.12,0,1,1,222.91,213.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.43,229.22c-7.7,2.15-21.52-9.19-27.18-18.61-.38-.65.35-7.64.84-16.19.27-5.19.46-11,.25-16.26-.05-1.08,33.49,6.73,33.49,6.73s-2.82,11.21-2.39,20.43a12,12,0,0,0,.31,2.16c0,.1.05.22.07.36C259.65,211.94,260.87,227.14,253.43,229.22Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.42,208.15a20.5,20.5,0,0,0,3.39-.31,2.69,2.69,0,0,0-.06-.36,11.13,11.13,0,0,1-.31-2.16c-.42-9.21,2.38-20.43,2.38-20.43s-27.22-6.34-32.58-6.81C229.51,184.15,235.84,208.51,255.42,208.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.75,132.14c-6,10.74-7.18,45.28-.62,54.47,9.52,13.32,28.71,18.58,40.94,6.31C281.92,181,282.65,136,275,127.27,263.68,114.42,238.64,116.28,229.75,132.14Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.46,135.86a13.09,13.09,0,0,1-11.86,4.66c-4.38-.63-8.77-3.56-10.41-7.77a.11.11,0,0,0-.2.08c1.76,4.49,5.5,8.15,10.45,8.74a13.49,13.49,0,0,0,12.27-5.5C269.83,135.9,269.59,135.7,269.46,135.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.47,107.88c-5.44-1.46-11.4,1.16-14.62,5.63a19.39,19.39,0,0,0-3.32,9.08.11.11,0,0,0,.21,0c.93-5.13,4.14-10.32,8.91-12.66a11.82,11.82,0,0,1,13.61,1.78,12,12,0,0,1,3.66,7.08.24.24,0,0,0,.47-.06A12.24,12.24,0,0,0,256.47,107.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,120.43a15.71,15.71,0,0,0-6.89-8.37c-4.45-2.64-9.41-2.14-14.33-1.55a.11.11,0,0,0,0,.21c4.19-.49,8.47-.75,12.37,1.16a15.53,15.53,0,0,1,7.33,7.42,15.15,15.15,0,0,1-5.92,18.92,15.37,15.37,0,0,1-12.11,1.46c-.15,0-.27.19-.1.24a15.46,15.46,0,0,0,19.63-19.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.81,136.78s.6-10.55,3.33-13.78,8.77-4,8.77-4,3.52-8.93,12-9.53c7.64-.54,12.82,6.2,12.82,6.2s10.56-10.51,22.65-4.56c11.48,5.65,10,23.12-1.05,28.72-7.8,3.92-18.55-2.87-18.55-2.87-1,.15-11.43,6.63-19.49-2.63,0,0-7.15,5.6-11.28,1.69C237,136,231.54,138.66,227.81,136.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.45,124.55c-.37,5.22-1.57,20.08-3.47,23.34s-6.43,11.79-8.27,12.39c.2-11.23,2-22.72,5-28.14A24.39,24.39,0,0,1,236.45,124.55Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,160.09s-5.42-12.27-10.85-10.54-2.83,18.48,2.5,21.75a6,6,0,0,0,8.45-1.6Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,154.33c-.09,0-.14.1-.06.15,3.7,2.42,5.09,6.58,5.81,10.75-.9-1.73-2.37-2.87-4.65-1.84-.12.06,0,.24.07.24a3.64,3.64,0,0,1,3.7,2,17.12,17.12,0,0,1,1.27,3.58c.12.39.8.33.75-.11a.36.36,0,0,0,0-.1C227.53,163.91,225,155.93,219.54,154.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.6,159.5c0-.09-.19.1-.19.2,0,2.33-.42,5-2.56,5.69-.06,0-.06.13,0,.13C253.45,165.25,254,161.71,253.6,159.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.61,157c-3.73-.42-4.31,7.07-.85,7.46S254.74,157.35,251.61,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.19,160.49c0-.09.18.12.17.21-.26,2.32-.16,5,1.88,6,.07,0,.05.14,0,.12C267.68,166.22,267.58,162.64,268.19,160.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.45,158.22c3.76,0,3.47,7.52,0,7.51S267.3,158.22,270.45,158.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.88,152.34c.88-.58,1.79-1,2.72-1.46a5,5,0,0,1,3.06-1,1.6,1.6,0,0,1,1.25,1.49c0,1.5-1.14,2.5-2.38,3.21a5.79,5.79,0,0,1-4.1.77A1.7,1.7,0,0,1,247.88,152.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.11,155.32a30.1,30.1,0,0,0-2.42-1.93,5,5,0,0,0-2.83-1.49,1.6,1.6,0,0,0-1.5,1.24c-.24,1.48.68,2.66,1.77,3.58a5.79,5.79,0,0,0,3.89,1.5A1.69,1.69,0,0,0,275.11,155.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,177.64c3-1,6.78-.31,9.16.16.27,0,.55-.54.61-.78v0c0-.09.2-4.92.2-4.92.62.37,3.81,2.08,3.82,1.15.08-7.67.17-16.2-1.37-23.85a.21.21,0,0,0-.42,0c-.37,7.37.56,14.76.3,22.16a13.54,13.54,0,0,0-3.6-1.37c-.26.05.06,5.21-.09,6,0,0-4.58-1.74-8.58.43C253.43,177.19,253,178.1,254.43,177.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.49,180.74c.52.58,1,1.35,1.85,1.48a6,6,0,0,0,2.51-.42.08.08,0,0,1,.09.13,3.1,3.1,0,0,1-3,1,2.45,2.45,0,0,1-1.68-2.15C249.24,180.7,249.42,180.66,249.49,180.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.09,154.16c-3.17,0-1.47-6-.8-8.07a38.32,38.32,0,0,0,.8-6.72,36.4,36.4,0,0,0,.83,6.72C240.58,148.17,242.28,154.16,239.09,154.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,170.36c.25-2.75.44-5.49.56-8.24s.21-5.49.19-8.24-.06-5.48-.19-8.23c0-1.37-.14-2.74-.25-4.11s-.24-2.75-.31-4.13a64.54,64.54,0,0,1,1.33,8.18,76.77,76.77,0,0,1,.42,8.3,82.18,82.18,0,0,1-.42,8.29c-.15,1.37-.32,2.74-.52,4.11S279.11,169,278.77,170.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.78,451.47c.07.41.15.82.23,1.24-.07-.41-.15-.83-.22-1.24Z",
    style: {
      fill: "#ebebeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeelingsorryCuate);
export default __webpack_public_path__ + "static/media/Feeling sorry-cuate.59327dd9316eeb8582a92f18bffb212e.svg";
export { ForwardRef as ReactComponent };